import { API_ENDPOINTS } from "config/config";
import { resolveDateRangeParams, PRESET_DATE_RANGE_TYPES } from "utils/dateRangeParams";

const buildGa4Params = (params = {}) => {
  const { filters, ...rest } = params;
  if (!filters?.dateRangeType || filters.dateRangeType === "allTime") {
    return { ...rest };
  }

  if (PRESET_DATE_RANGE_TYPES.has(filters.dateRangeType)) {
    return { dateRangeType: filters.dateRangeType, ...rest };
  }

  return { ...resolveDateRangeParams(filters), ...rest };
};

export const getGa4Status = async (api) => {
  const response = await api.get(API_ENDPOINTS.GA4_STATUS);
  return response.data.data;
};

export const syncGa4 = async (api, params = {}) => {
  const response = await api.post(
    API_ENDPOINTS.GA4_SYNC,
    {},
    { params: buildGa4Params(params) }
  );
  return {
    data: response.data.data,
    message: response.data.message,
  };
};

export const getGa4Metrics = async (api, params = {}) => {
  const response = await api.get(API_ENDPOINTS.GA4_METRICS, {
    params: buildGa4Params(params),
  });
  return response.data.data;
};

export const getGa4TrafficSources = async (api, params = {}) => {
  const response = await api.get(API_ENDPOINTS.GA4_TRAFFIC_SOURCES, {
    params: buildGa4Params(params),
  });
  return response.data.data;
};

export const getGa4LandingPages = async (api, params = {}) => {
  const response = await api.get(API_ENDPOINTS.GA4_LANDING_PAGES, {
    params: buildGa4Params(params),
  });
  return response.data.data;
};

export const getGa4Events = async (api, params = {}) => {
  const { groupBy, eventNames, ...rest } = params;
  const response = await api.get(API_ENDPOINTS.GA4_EVENTS, {
    params: {
      ...buildGa4Params(rest),
      ...(groupBy ? { groupBy } : {}),
      ...(eventNames?.length ? { eventNames: eventNames.join(",") } : {}),
    },
  });
  return response.data.data;
};
